import { CreditNoteSaleProductSummary } from '../../../types/sale/creditNote/CreditNoteSaleDetail';

export const mapToProductSummaries = (raw: any[]): CreditNoteSaleProductSummary[] => {
  return raw.map((item) => ({
    saleDetailId: item.product.saleDetailId,               // ✅ OK
    productId: item.product.productId,                     // ✅ OK
    productName: item.product.productName,                 // ✅ OK
    unit: item.product.unit,                               // ✅ OK
    quantity: item.product.quantity,                       // ✅ OK
    unitPrice: item.product.unitPrice,                     // ✅ OK
    discount: item.product.discount,                       // ✅ OK
    total: item.product.total,                             // ✅ OK
    imagePath: item.product.imagePath,                     // ✅ OK
    creditFiscalId: item.product.creditFiscalId,           // ✅ OK
    creditFiscalDocumentNumber: item.product.creditFiscalDocumentNumber, // ✅ NUEVO CAMPO

    // ✅ Campos de balance (opcional si vienen en respuesta)
    soldQuantity: item.balance?.soldQuantity ?? 0,
    returnedQuantity: item.balance?.returnedQuantity ?? 0,
    remainingQuantity: item.balance?.remainingQuantity ?? 0,
    canBeReturned: item.balance?.canBeReturned ?? false,
  }));
};
